import { render } from "./MyOrder.vue?vue&type=template&id=25549e2e"
import script from "./MyOrder.vue?vue&type=script&lang=js"
export * from "./MyOrder.vue?vue&type=script&lang=js"

import "./MyOrder.vue?vue&type=style&index=0&id=25549e2e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__